import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import styled from '@emotion/styled'
import { FocusSpan, underlineFocus } from './focus-styles'

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.system_blue.color};
  text-decoration: none;

  ${underlineFocus}
`

const TextLink = ({ after, before, children, ...rest }) => (
  <StyledLink {...rest}>
    {before}
    <FocusSpan>{children}</FocusSpan>
    {after}
  </StyledLink>
)

TextLink.propTypes = {
  after: PropTypes.node,
  before: PropTypes.node,
  children: PropTypes.node,
}

export default TextLink
